import M from 'materialize-css';
import jq from 'jquery';
require('select2');

function initSelects() {
    // Selects, with Materializecss OR Select2.js
    var selects = document.querySelectorAll('select');
    for (let i=0; i<selects.length; i++) {
        if ( selects[i].classList.contains('browser-default') ) continue;
        if ( selects[i].classList.contains('flatpickr-monthDropdown-months')) continue;
        if ( selects[i].classList.contains('search') ) {
            jq(selects[i]).select2({
                theme: 'material',
            });

        } else {
            M.FormSelect.init(selects[i], {});
        }
    }
}

export default initSelects;

